import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DailyOrders from "./pages/DailyOrders";
import Employees from "./pages/Employees";
import EmployeeAccount from "./pages/EmployeeAccount";
import EmployeeBalances from "./pages/EmployeeBalances";
import Payments from "./pages/Payments";
import OutstandingPayments from "./pages/OutstandingPayments";
import Restaurants from "./pages/Restaurants";
import Reports from "./pages/Reports";
import SalaryDeductions from "./pages/SalaryDeductions";
import AuditLog from "./pages/AuditLog";
import ReminderLog from "./pages/ReminderLog";
import Admins from "./pages/Admins";
import Settings from "./pages/Settings";
import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeePortal from "./pages/EmployeePortal";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function EmpProtected({ children }) {
  const token = localStorage.getItem("emp_token");
  if (!token) return <Navigate to="/portal/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/portal/login" element={<EmployeeLogin />} />
          <Route path="/portal" element={<EmpProtected><EmployeePortal /></EmpProtected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/orders" element={<DailyOrders />} />
            <Route path="/employees" element={<Employees />} />
            <Route path="/employees/:id" element={<EmployeeAccount />} />
            <Route path="/balances" element={<EmployeeBalances />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/outstanding" element={<OutstandingPayments />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/deductions" element={<SalaryDeductions />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/reminder-log" element={<ReminderLog />} />
            <Route path="/admins" element={<Admins />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
